export const ENV = process.env.REACT_APP_ENV;
export const GOOGLE_MAP_API_KEY = process.env.REACT_APP_GOOGLE_MAP_API_KEY;
export const MAPBOX_API_KEY = process.env.REACT_APP_MAPBOX_API_KEY;
export const BCDATA_API_ENDPOINT =
    "https://us-west1-logitnow.cloudfunctions.net/logit-bcdata-api";
// "https://us-west1-logitnow-dev.cloudfunctions.net/logit-bcdata-api"; // dev
// "http://localhost:8089";

export const BCDATA_API_ENDPOINT_V2 =
    "https://us-west1-logitnow.cloudfunctions.net/https-logit-bcdata/v1/api";
// "http://localhost:8085/v1/api";

export const NEW_SALE_THRESHOLD = 3;
export const CLOSING_SALE_THRESHOLD = 7;
export const CUSTOMER_SERVICE_EMAIL = "support@logitnow.ca";
export const TIMBER_SALE_LIST_PAGE_LIMIT = 25;
export const FREE_TRIAL_DAYS = 14;

/**
 * Harvest Billing System
 */
export const HBS_WEIGHT_SCALE_SUMMARIES = `https://a100.gov.bc.ca/pub/hbs/opq/dac/ConfigureScaleSiteSummary.do?radGroupType=ScaleSitePopulation&radScaleType=W&chcScaleDateFromDate=<<from>>&chcScaleDateToDate=<<to>>&radScaleSite=All&radTimberMark=Single&txtTimberMark=<<timbermark>>&txtScaleSite=&chcStatus=&chcDistrictScaled=&chcDistrictHarvested=&chcClientType=&txtClientNo=&txtClientLoc=&txtPop=&txtStrat=&txtYear=&txtScalerLicence&actionType=View+PDF+Report`;
